import React from 'react';

type SvgProps = {
  strokeColor?: string;
  fillColor?: string;
};

const MasterdataIcon: React.FC<SvgProps> = ({ strokeColor = '#CBD2D9' }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.6666 13.6074H1.33331V27.9998H30.6666V13.6074Z"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.6666 13.6082H1.33331V3.29883H11.9483L13.986 7.38176H30.6666V13.6082Z"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MasterdataIcon;
